/* eslint-disable sonarjs/cognitive-complexity */
import { FC } from 'react'
import { TheatricalReleaseResult } from '@/services/Theatrical/queries'
import { useSafeRouter } from '@/utils/nextUtils/safe-router'
import { useTranslate } from '@/utils/translate/translate-client'
import ChangeReservationBanner from '@/views/TicketCheckoutViews/ShowtimesView/components/banners/ChangeReservationBanner'
import { TicketPromoBanners } from '@/views/TicketCheckoutViews/ShowtimesView/components/banners/DiscountBanner/TicketPromoBanners'
import { isAngelIntegratedCountry } from '@/views/TicketCheckoutViews/ShowtimesView/utils/utils'
import { InitializedReservation } from '../initReservation'

interface BannerSectionProps {
  reservation?: InitializedReservation
  isEditReservationFlow: boolean
  theatricalRelease: TheatricalReleaseResult
}

const TicketBannerSection: FC<BannerSectionProps> = ({ reservation, isEditReservationFlow, theatricalRelease }) => {
  const { t } = useTranslate('tickets')
  const { isReady } = useSafeRouter()
  const countryCode = theatricalRelease?.region?.countryCode

  return (
    <>
      {!isEditReservationFlow && !!theatricalRelease?.theatricalSlug && (
        <TicketPromoBanners
          theatricalSlug={theatricalRelease?.theatricalSlug}
          projectName={theatricalRelease?.title ?? ''}
        />
      )}

      {!!reservation?.priorReservation?.id &&
        !!reservation?.isChangeReservation &&
        isAngelIntegratedCountry(countryCode) &&
        isReady && (
          <ChangeReservationBanner
            description={t('pleaseSelectANewShowtimeBelow', 'Please select a new showtime below.')}
            priorReservation={reservation?.priorReservation}
            step={1}
          />
        )}
    </>
  )
}

export default TicketBannerSection
